module.exports = __webpack_public_path__ + "img/i.a3406926.svg";